import { AxiosRequestConfig } from 'axios';
import {
  ClassificationType,
  ClassificationTypeEntityEnum,
} from '../../../modules/classifications/classification.types';
import { Pagination } from '../../../types/pagination.type';
import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { BRAND_ID_HEADER_KEY, restApi } from '../../api';
import {
  FindClassificationTypesOutput,
  FindClassificationTypesParams,
  FindProps,
  UpdateInput,
} from './classificationTypes.types';

const PATH = 'classification-types';

const onlineClassificationTypesRepository = () => {
  return {
    create: async (name: string, entity: ClassificationTypeEntityEnum) =>
      restApi.post<ClassificationType>(PATH, {
        name,
        code: name,
        entity,
      }),

    delete: async (id: string) => restApi.delete<void>(`${PATH}/${id}`),

    update: async (id: string, input: UpdateInput) =>
      restApi.patch<ClassificationType>(`${PATH}/${id}`, input),

    find: async (params?: FindProps, brandId?: string, signal?: AbortSignal) => {
      let axiosConfig: AxiosRequestConfig = {};
      if (brandId) {
        axiosConfig = { headers: { [BRAND_ID_HEADER_KEY]: brandId } };
      }
      return restApi.get<Pagination<ClassificationType>>(PATH, params, {
        ...axiosConfig,
        cancelToken: cancelTokenFromSignal(signal)?.token,
      });
    },

    findClassificationTypes: (params: FindClassificationTypesParams) =>
      restApi.get<FindClassificationTypesOutput>(PATH, params),

    findClassificationTypesNoRbac: (params: FindClassificationTypesParams) =>
      restApi.get<FindClassificationTypesOutput>(`${PATH}/no-rbac`, params),
  };
};

export default onlineClassificationTypesRepository;
